import React, { useState, useEffect } from "react"

import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap"
import { Link } from "react-router-dom"

// import actions
import { connect } from 'react-redux';
import {
	setAllCategories,
	setAllMerchants
} from "../../store/cms-actions/postActions";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import SweetAlert from "react-bootstrap-sweetalert"
import { CheckPermission } from "../Permissions/CheckPermissions";
import { FaPen , FaRegTrashAlt, FaPlus, FaCloudUploadAlt} from "react-icons/fa";


const MPMakanMaster = (props) => {

  const sortOptions = [
    { id: 1, value: "enabled", label: "Enabled" },
    { id: 2, value: "all", label: "All" }
  ]

  const [data, setData] = useState([])
  const [sortBy, setSortBy] = useState(sortOptions[0].value)
  const [token, setToken] = useState('')
  const [success_msg, setsuccess_msg] = useState(false)
  const [errorMessage, SetErrorMessage] = useState('')
  const [errorMsgAlert, setErrorMsgAlert] = useState(false)
  const [ItemForDelete, setItemForDelete] = useState("")
  const [del, setDelete] = useState(false)

  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken")
    setToken(token)
    getMarketPlacebanner(token)
    return () => {
    }
  }, [sortBy, success_msg])



  const handleConfirmation = () => {
    return (
      <SweetAlert
        title="Warning"
        warning
        showCancel={true}
        showConfirm={true}
        btnSize="lg"
        confirmBtnText="Delete"
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="secondary"
        onConfirm={() => {
          deleteEntry(ItemForDelete?.id, token)
          setDelete(false)
        }}
        onCancel={() => setDelete(false)}
        show={true}>
        {"Are you sure you want to delete ?"}
      </SweetAlert>
    )
  };
  const getMarketPlacebanner = (token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("Cookie", "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208");

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/marketplacebanners/`, requestOptions)
      .then(response => response.json())
      .then(result => {
        let tempData = []
        if (result) {
          result?.data.map((item) => {
            if (item.page.includes("makan_master")) {
              tempData = [...tempData, item]
            }
          })
          /*Sorting according to postion and date */
          tempData.sort((a, b) => {
            if (a.sort_order == b.sort_order) {
              return (Date.parse(b.publish_date) - Date.parse(a.publish_date))
            }
            else {
              return a.sort_order - b.sort_order;
            }
          })
          // autoDisableBanners(tempData, token)
          setData(tempData)
        }
      })
      .catch(error => console.log('error', error));
  }

  const deleteEntry = (ID, token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
      method: 'DELETE',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/marketplacebanners/${ID}`, requestOptions)
      .then(response => {
        if (response.status == 202) {
          setsuccess_msg(true)
        } else {
          setErrorMsgAlert(true)
        }
        response.text()
      })
      .then(result => console.log(result))
      .catch(error => console.log('error', error));

  }
  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        onConfirm={() => {
          setsuccess_msg(false)
          props.history.go(0)
        }}
        onCancel={() => {
          setsuccess_msg(false)
        }}
      >
        {"MakanMaster MarketPlace Banner deleted successfully."}
      </SweetAlert>
    )
  }
  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorMsgAlert(false)
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    )
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Market Place Banners" breadcrumbItem="Makan Master" />

          <Row>
            <Col>
              <Card>
                <CardBody>
                  <CardTitle className="h4">
                    <Row>
                      <Col lg={6} md={12} sm={12}>
                        <Button
                         disabled={!CheckPermission("marketplacebanners","add")}
                          className="btn btn-success waves-effect waves-light"
                          onClick={() => {
                            props?.history?.push("/add-market-place-banner", { makan_master: true })
                          }}
                        >
                          <FaPlus size={12} />{" "}
                          Add Makan Master Banner
                        </Button>
                      </Col>
                      <Col lg={6} md={12} sm={12}
                        style={{ textAlign: "right" }}>
                        <div className="mb-3">
                          {/* <Label>Discount Type</Label> */}
                          <label htmlFor="cars">Status</label>

                          <select name="cars" defaultValue={sortOptions[0].value} id="cars" onChange={(e) => { setSortBy(e.target.value) }}
                            style={{ width: 80, height: 30, marginLeft: 10 }}>
                            {sortOptions?.map((item, index) => {
                              return (
                                <option key={index} value={item.value}>{item.label}</option>
                              )
                            })}
                          </select>
                        </div>
                      </Col>
                    </Row>
                  </CardTitle>

                  <div className="table-responsive">
                    <table className="table table-bordered border-primary mb-0">

                      <thead>
                        <tr>
                          <th>Image</th>
                          <th style={{width:"10%"}}>Name</th>
                          {/* <th>Publish At</th>
                          <th>Unpublish At</th> */}
                          <th style={{width:"8%"}}>Status</th>
                          <th style={{width:"7%"}}>Action</th>
                          {/* <th>Position</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {data?.map((item, index) => {
                          if (sortBy == "enabled") {
                            if (item?.item_status !== "Y") {
                              return
                            }
                          }
                          return (
                            <tr key={index}>
                              <th scope="row">
                                <img
                                  src={item?.userfile}
                                  style={{ width: 250 }}
                                  alt=""
                                />
                              </th>
                              <td>{item?.page}</td>
                              {/* <td>{moment(item?.publish_date).format("DD/MM/YYYY h:mm a")}</td>
                              <td>{item?.unpublish_date == null ? "Never-Ending" : moment(item?.unpublish_date).format("DD/MM/YYYY h:mm a")}</td> */}
                              <td>
                                {item?.item_status == "Y" ?
                                  <Button color="success" className="btn-soft-success waves-effect waves-light">Enabled</Button>
                                  :
                                  <Button color="danger" className="btn-soft-danger waves-effect waves-light">Disabled</Button>
                                }
                              </td>
                              <td>
                                <Row>
                                  <div className="d-flex justify-content-around">
                                   {CheckPermission("marketplacebanners","update") && <div style={{ width: 30, textAlign: "center" }}
                                      onClick={() => {
                                        props?.history?.push("/edit-market-place-banner",{ item ,edit:true,makan_master:true})
                                      }}
                                      className="text-primary"><a className="uil uil-pen font-size-18"
                                        onClick={() => {
                                          props?.history?.push("/edit-market-place-banner", { item ,edit:true,makan_master:true})
                                        }}
                                      ></a>
                                    </div>}
                                    {success_msg ? (
                                      renderSuccessAlert()
                                    )
                                      :
                                      null
                                    }
                                    {errorMsgAlert ? (
                                      renderFailureAlert()
                                    )
                                      :
                                      null
                                    }
                                    {/* onClick={() => { deleteEntry(item?.item_id, token) }} */}
                                    {CheckPermission("marketplacebanners","delete")&&<div style={{ width: 30 }} >
                                      <Link to="#" className="px-2 text-danger">
                                        <i className="uil uil-trash-alt font-size-18" onClick={() => {
                                          setItemForDelete(item)
                                          setDelete(true)
                                        }}>
                                        </i>
                                      </Link>
                                    </div>}
                                  </div>
                                </Row>
                              </td>
                              {/* <td>{item?.sort_order}</td> */}
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
        {del ? handleConfirmation() : null}
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
	const { allCategories, allMerchants } = state.rootReducers1
	return { allCategories, allMerchants }
};

const actions = {
	setAllCategories,
	setAllMerchants,
};

export default connect(mapStateToProps, actions)(MPMakanMaster)
